import React from 'react';
import { UI_TEXT } from '../constants';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = UI_TEXT.LOADING
}) => {
  return (
    <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl p-8 shadow-2xl text-center">
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-blue-200 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-blue-500 rounded-full border-t-transparent animate-spin"></div>
        </div>

        <p className="text-gray-700 font-medium">{message}</p>
      </div>
    </div>
  );
};

export type { LoadingSpinnerProps };
export { LoadingSpinner };
export default LoadingSpinner;